import React, {useEffect, useState} from 'react';
import Grid from '@mui/material/Grid2';
import {Styles} from '../../../config/design/styles';
import { withStyles } from '@mui/styles';
import {useSnackbar} from "notistack";
import axios from "axios";
import {defaultVariables} from "../../../config";
import {useTranslation} from "react-i18next";
import {useNavigate} from "react-router-dom";

import {connect, setStore} from "trim-redux";
import EditorPreviewHTML from "../../components/editor/EditorPreviewHTML";
import AppCardLoaderFields from "../../components/loaders/AppCardLoaderFields";

function ShowPageContent({classes,setting,slug,setPageData}){
    const { t } = useTranslation();

    const [page, setPage] = useState([]);
    const [loading, setLoading] = useState(true);
    const [fetching, setFetching] = useState(false);
    const navigation = useNavigate();
    const config = {
        headers: {
            Accept: 'application/json',
        }
    }
    const { enqueueSnackbar } = useSnackbar();
    const loadData = () =>{
        setFetching(true);
        const savedLang = localStorage.getItem('language') || 'tr';
        axios.get(`${defaultVariables.url}/front/page/${savedLang}_${slug}`,config)
            .then(response => {
                setPage(response.data);
                setPageData(response.data);
                setLoading(false);
                setFetching(false);
            })
            .catch(error => {
                console.error("Error fetching item data:", error);
                setLoading(false);
                setFetching(false);
                setStore({error:404})
            });
    }

    useEffect(() => {
        if (!fetching) {
            loadData();
        }
    },[slug]);

    return (
        <div>
            {
                loading ?
                    <AppCardLoaderFields/>
                    :
                    <EditorPreviewHTML html={page.data?.html} />
            }

        </div>
    );
}
const mapStateToProps = (state) => ({
    setting: state.setting,
});

export default withStyles(Styles)(connect(mapStateToProps)(ShowPageContent));
